import React from 'react';
import {
  Button,
  Row,
  Modal,
  ModalProps,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { v4 as uuid } from 'uuid';
import { fetchPatternCodeList } from 'services/inventory';
import { SmartSpace } from '../SmartComponent';
import { PoRecvActionType as PRAction } from './context';

type Props = ModalProps & {
  dispatch: Function;
  onClosePatternCodeSelectorWithoutSelection?: Function;
  onSelectPatternCode?: Function;
  state: StringKAnyVPair;
};

const PatternCodeSelector = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const [patternCodeList, setPatternCodeList] = useState<StringKAnyVPair[]>([]);

  const dialogFooter = () => {
    return (
      <Row justify="center">
        <Button
          onClick={onCancel}
          size="large"
        >
          Don't Use Pattern Code
        </Button>
      </Row>
    );
  };

  const dialogTitle = () => {
    return (
      <Row align="middle" justify="space-between">
        {props.title || <span>&nbsp;</span>}
        <CloseOutlined onClick={onCancel} />
      </Row>
    );
  };

  // eslint-disable-next-line
  const loadPatternCodeList = async () => {
    const { dispatch } = props;

    dispatch({ type: PRAction.SetLockScreen, params: true }); 
    try {
      const res = await fetchPatternCodeList({ status: 1 }) as any;

      if (res && typeof res === 'object' && res.isSuccess) {
        if (Array.isArray(res.data)) {
          //console.log(res.data, '<--');
          setPatternCodeList(res.data.map((e: any) => ({ ...e, uuid: uuid() })));
        }
      }
    } catch(e) {
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  const onCancel = (evt: any) => {
    props.onCancel && props.onCancel(evt);
    props.onClosePatternCodeSelectorWithoutSelection && setTimeout(
      props.onClosePatternCodeSelectorWithoutSelection, 0);
  };

  const onSelectPatternCode = (p: StringKAnyVPair) => {
    const { dispatch } = props;
    //console.log('p', p);
    dispatch({ type: PRAction.SetPatternCode, params: { ...p } }); 
    props.onSelectPatternCode && props.onSelectPatternCode(p);
    // @ts-ignore
    props.onCancel && props.onCancel(undefined); // can not call onCancel here
  };

  const renderPatternCodeList = () => {
    return patternCodeList.map(e => (
      <Row
        className="fs-20 li-row bb-solid-1 p-12"
        key={`pck=${e.uuid}`}
        onClick={() => onSelectPatternCode(e)}
      >
        {e.name}
      </Row>
    ));
  };

  React.useEffect(() => {
    if (!inited) {
      loadPatternCodeList();
      setInited(true);
    }
  }, [inited, loadPatternCodeList]);

  return (
    <Modal
      { ...props }
      closable={false}
      footer={dialogFooter()}
      title={dialogTitle()}
    >
      <SmartSpace className="y-scrollable" style={{ height: 300 }}>
        {renderPatternCodeList()}
      </SmartSpace>
    </Modal>
  );
};

export default PatternCodeSelector;
